__webpack_require__.p = "/project-2023-data-connoisseurs/";